import {
  truncateForShareUrl,
  VIBER_FORWARD_URL_PREFIX,
  WA_ME_URL_PREFIX,
} from './offerShareText'

export type ShareAction = 'copy' | 'email' | 'native' | 'viber' | 'whatsapp' | 'sms'

export const SHARE_ACTION_LABELS: Record<ShareAction, string> = {
  copy: 'Αντιγραφή',
  email: 'Email',
  native: 'Κοινοποίηση',
  viber: 'Viber',
  whatsapp: 'WhatsApp',
  sms: 'SMS',
}

export const SHARE_ACTIONS: ShareAction[] = ['copy', 'native', 'viber', 'whatsapp', 'sms']

export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    /* HTTP/LAN */
  }
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch {
    return false
  }
}

export async function runShareAction(
  action: ShareAction,
  message: string,
  options?: { copyLabel?: string; emailSubject?: string; emailTo?: string },
): Promise<void> {
  const value = message.trim()
  if (!value) return

  switch (action) {
    case 'copy': {
      const copied = await copyTextToClipboard(value)
      if (!copied) {
        window.alert('Δεν ήταν δυνατή η αντιγραφή.')
      }
      return
    }
    case 'email': {
      const subject = options?.emailSubject?.trim() || 'Επαγγελματικό προφίλ'
      const to = options?.emailTo?.trim()
      const mailto = to
        ? `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(value)}`
        : `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(value)}`
      window.location.href = mailto
      return
    }
    case 'native': {
      if (navigator.share && typeof navigator.share === 'function') {
        try {
          await navigator.share({ text: value })
          return
        } catch (e) {
          if (e instanceof Error && e.name === 'AbortError') return
        }
      }
      await copyTextToClipboard(value)
      return
    }
    case 'whatsapp': {
      const text = truncateForShareUrl(value, WA_ME_URL_PREFIX)
      window.open(
        `${WA_ME_URL_PREFIX}${encodeURIComponent(text)}`,
        '_blank',
        'noopener,noreferrer',
      )
      return
    }
    case 'viber': {
      const text = truncateForShareUrl(value, VIBER_FORWARD_URL_PREFIX)
      window.open(
        `${VIBER_FORWARD_URL_PREFIX}${encodeURIComponent(text)}`,
        '_blank',
        'noopener,noreferrer',
      )
      return
    }
    case 'sms': {
      window.location.href = `sms:?body=${encodeURIComponent(value)}`
      return
    }
    default:
      return
  }
}
